import { decode } from 'he';

const removeHTML = (input: string): string => {
  // Remove HTML tags and their attributes using a regular expression
  const plainText = input.replace(/<[^>]*>/g, '');

  // Decode the HTML entities in the plain text
  const cleanedString = decode(plainText);

  return cleanedString;
};

export default removeHTML;
